(function Index($, Adzuki)
{
	"use strict";

	var $modal;
	var refresh_interval = null;

	Adzuki.onload('LivePlanner/index', function onload() {
		$('body').addClass('lp-session');

		refresh_interval = window.setInterval(function interval() {
			// don't reload clients if the tooltip is open
			if ($('#qtip-blanket').is(':visible')) {
				return;
			}

			_loadWebsiteVisitors();
			_loadScheduledAppointments();
		}, 15000);

		_loadWebsiteVisitors();
		_loadScheduledAppointments();
	});

	Adzuki.onload('/LivePlanner/manageTasks/', function onload()
	{
		Adzuki.TaskManager.loadEntityTasks('live_planner_appointment');
	});

	function _addEventHandlers()
	{
		// click the button to reload the clients on the website
		$('.reload').off().on('click', function _reloadClicked(e) {
			$(this).html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i> Reload');
		});

		// click on icon to start an LP session
		$('.lp-start-lnk').off().on('click', function _startLink(e) {
			var web_session_id = $(this).data('web-session-id');
			var client_id      = $(this).data('client-id');
			var appointment_id = $(this).data('appointment-id');
			var video_on       = $(this).data('video-on');

			e.preventDefault();

			window.clearInterval(refresh_interval);
			refresh_interval = null;

			Adzuki.Ajax.get('/LivePlanner/sessionCheck/')
			.then(function _sessionCheck(response) {
				var start_url = '/LivePlanner/sendStart/';
				start_url    += web_session_id + '/';
				start_url    += client_id;

				// tie an appointment to the session
				if (appointment_id) {
					start_url += '/' + appointment_id;
				} else {
					start_url += '/0';
				}

				// start the session with video automatically
				if (video_on) {
					start_url += '/' + video_on;
				} else {
					start_url += '/0';
				}

				if (response.lp_zoom_terms_agreed === null || response.lp_zoom_terms_agreed.length === 0) {
					Adzuki.CustomConfirm({
						title  : 'Zoom Terms of Service',
						body   : 'I acknowledge that I have read the <a href="https://explore.zoom.us/en/eula-terms-of-service/" target="_blank">Zoom Terms of Service</a> related to video meeting features available within LivePlanner.',
						confirm: function _acceptTerms() {
							Adzuki.Ajax.get('/LivePlanner/acceptZoomTerms')
							.then(function _acceptZoomTerms(response) {
								if (response.lp_zoom_terms_agreed) {
									_openSessionStartModal(start_url);
									return;
								}

								Adzuki.StatusMessage('error', 'There was a problem saving the Zoom Terms of Service, please try again.');
							});
						}
					});
				} else if (response.open_sessions.length > 0) {
					start_url += '/1';

					Adzuki.CustomConfirm({
						title  : 'Decision Time',
						content: 'It appears that you already have open sessions. Here is what we\'ve detected: <br><br>' + response.open_sessions + 'Would you like to end all of these sessions and continue?',
						confirm: function confirm() {
							_openSessionStartModal(start_url);
						}
					});
				} else {
					_openSessionStartModal(start_url);
				}
			});
		});

		// when checking/unchecking the checkbox to see the primary clients
		$('.display-primary-only').on('change', function _togglePrimaryClents(e) {
			_loadScheduledAppointments();
		});

		// when changing the selected appointment (if any)
		$('.appt-title-select').on('change', function _onAppointmentChange(e) {
			_loadScheduledAppointments();
		});

		// click on icon to view upcoming appointments
		$('.lp-view-appt-lnk').off().on('click', function _viewAppointment(e) {
			var client_id = $(this).data('client-id'),
				$modal    = $('.modal');

			e.preventDefault();

			Adzuki.Ajax.get('/LivePlanner/upcomingAppointments/' + client_id)
			.then(function _receiveContent(content) {
				$modal.find('.modal-title').text('Upcoming appointments');
				$modal.find('.modal-body').html(content);
				$modal.modal('show');
			});
		});

		// init qtips
		Adzuki.QTip.attachQtip('.qtip-schedule-link', undefined, undefined, 'left');
	}

	function _loadScheduledAppointments()
	{
		var url            = '/LivePlanner/scheduledAppointments';
		var primary_only   = $('#primary_only').first().is(':checked');
		var appointment_id = $('.appt-title-select').first().val();

		if (primary_only) {
			url += '/1';
		} else {
			url += '/0';
		}

		if (appointment_id) {
			url += '/' + appointment_id;
		} else {
			url += '/0';
		}

		Adzuki.Ajax.get(url).then(function scheduledAppointments(response) {
				$('#scheduled-appointments').html(response);

				_addEventHandlers();
			}
		);
	}

	function _loadWebsiteVisitors()
	{
		Adzuki.Ajax.get('/LivePlanner/webVisitors')
		.then(function webVisitors(response) {
				$('#web-visitors').html(response);

				_addEventHandlers();
			}
		);
	}

	function _openSessionStartModal(start_url)
	{
		// send the start session
		Adzuki.Ajax.get(start_url).then(function _sendStart(response) {
			$modal = $('.modal');
			$modal.find('.modal-dialog').addClass('secure-storage');
			$modal.find('.modal-title').text('Waiting on Client');
			$modal.find('.modal-body').html('<img src="' + Adzuki.base_uri + '/adzuki/images/econnect-loader.gif" class="img-responsive">');

			$modal.on('hidden.bs.modal', function _restoreModal() {
				$modal.find('.modal-dialog').removeClass('secure-storage');
				$modal.off('hidden.bs.modal');
			});

			$modal.modal('show');
		});
	}
}(jQuery, window.Adzuki || {}));
